import React, { lazy } from 'react';
const VapolinkApp = lazy(() => import('./clients/vapolink/VapolinkApp'));
const WikiPapaApp = lazy(() => import('./clients/wikipapa/WikiPapaApp'));
const FluizyApp = lazy(() => import('./clients/fluizy/FluizyApp'));
const IdelinkApp = lazy(() => import('./clients/idelink/IdelinkApp'));
const IrritalkApp = lazy(() => import('./clients/irritalk/IrritalkApp'));
const MidaslinkApp = lazy(() => import('./clients/midaslink/MidaslinkApp'));
const ETribuApp = lazy(() => import('./clients/sylviethiriez/ETribuApp'));
const Auto5LinkApp = lazy(() => import('./clients/auto5link/Auto5LinkApp'));
const OBlinkApp = lazy(() => import('./clients/oblink/OBlinkApp'));
const FootKornerLinkApp = lazy(() => import('./clients/footkornerlink/FootKornerLinkApp'));
const AcuitislinkApp = lazy(() => import('./clients/acuitislink/AcuitislinkApp'));
const EngagedApp = lazy(() => import('./clients/engaged/EngagedApp'));
const PharmavanceApp = lazy(() => import('./clients/pharmavance/PharmavanceApp'));
const BasilinkApp = lazy(() => import('./clients/basilink/BasilinkApp'));
const NipponlinkApp = lazy(() => import('./clients/nipponlink/NipponlinkApp'));
const KapaApp = lazy(() => import('./clients/kapa/KapaApp'));
const FoirfouillelinkApp = lazy(() => import('./clients/foirfouillelink/FoirfouillelinkApp'));
const EntrenousApp = lazy(() => import('./clients/entrenous/EntreNousApp'));
const MeryPlusApp = lazy(() => import('./clients/meryplus/MeryPlusApp'));
const CrechesPlusApp = lazy(() => import('./clients/crechesplus/CrechesPlusApp'));
const GemgusApp = lazy(() => import('./clients/gemgus/GemGusApp'));
const LollysApp = lazy(() => import('./clients/lollys/LollysApp'));
const ChronolinkApp = lazy(() => import('./clients/chronolink/ChronolinkApp'));

export enum IdelinkCustomerApp {
	IDELIEN = 'IDELIEN',
	DEMOLINK = 'DEMOLINK',
	MIDASLINK = 'MIDASLINK',
	FLUIZY = 'FLUIZY',
	IRRITALK = 'IRRITALK',
	SYLVIETHIRIEZ = 'SYLVIETHIRIEZ',
	VAPOLINK = 'VAPOLINK',
	WIKIPAPA = 'WIKIPAPA',
	AUTO5LINK = 'AUTO5LINK',
	OBLINK = 'OBLINK',
	FOOTKORNERLINK = 'FOOTKORNERLINK',
	ACUITISLINK = 'ACUITISLINK',
	ENGAGED = 'ENGAGED',
	PHARMAVANCE = 'PHARMAVANCE',
	BASILINK = 'BASILINK',
	NIPPONLINK = 'NIPPONLINK',
	KAPA = 'KAPA',
	FOIRFOUILLELINK = 'LAFOIRFOUILLELINK',
	ENTRENOUS = 'ENTRENOUS',
	MERYPLUS = 'MERYPLUS',
	CRECHESPLUS = 'CRECHESPLUS',
	GEMGUS = 'GEMGUS',
	LOLLYS = 'LOLLYS',
	CHRONOLINK = 'CHRONOLINK',
}

//PGU TODO: J'ai été obligé de mettre chaque app en lazy loading. Sans ça toutes les apps sont chargées pour chaque client.
// ça pose bien évidemment un problème de performance.
// mais ça pose aussi un problème de style puisque les fichier css de toutes les app sont chargés pour chaque client.
// l'idéal serait d'avoir un fichier index.tsx différent pour chaque client.  >>> TODO!
export class IdelinkLauncher {
	public static getApp = (app: IdelinkCustomerApp | '__APP__'): React.ComponentType => {
		switch (app) {
			case IdelinkCustomerApp.DEMOLINK:
			case IdelinkCustomerApp.IDELIEN:
				return IdelinkApp;
			case IdelinkCustomerApp.MIDASLINK:
				return MidaslinkApp;
			case IdelinkCustomerApp.FLUIZY:
				return FluizyApp;
			case IdelinkCustomerApp.IRRITALK:
				return IrritalkApp;
			case IdelinkCustomerApp.SYLVIETHIRIEZ:
				return ETribuApp;
			case IdelinkCustomerApp.VAPOLINK:
				return VapolinkApp;
			case IdelinkCustomerApp.WIKIPAPA:
				return WikiPapaApp;
			case IdelinkCustomerApp.AUTO5LINK:
				return Auto5LinkApp;
			case IdelinkCustomerApp.OBLINK:
				return OBlinkApp;
			case IdelinkCustomerApp.FOOTKORNERLINK:
				return FootKornerLinkApp;
			case IdelinkCustomerApp.ACUITISLINK:
				return AcuitislinkApp;
			case IdelinkCustomerApp.ENGAGED:
				return EngagedApp;
			case IdelinkCustomerApp.PHARMAVANCE:
				return PharmavanceApp;
			case IdelinkCustomerApp.BASILINK:
				return BasilinkApp;
			case IdelinkCustomerApp.NIPPONLINK:
				return NipponlinkApp;
			case IdelinkCustomerApp.KAPA:
				return KapaApp;
			case IdelinkCustomerApp.FOIRFOUILLELINK:
				return FoirfouillelinkApp;
			case IdelinkCustomerApp.ENTRENOUS:
				return EntrenousApp;
			case IdelinkCustomerApp.MERYPLUS:
				return MeryPlusApp;
			case IdelinkCustomerApp.CRECHESPLUS:
				return CrechesPlusApp;
			case IdelinkCustomerApp.GEMGUS:
				return GemgusApp;
			case IdelinkCustomerApp.LOLLYS:
				return LollysApp;
			case IdelinkCustomerApp.CHRONOLINK:
				return ChronolinkApp;
		}
		return IdelinkApp;
	};
}
